<mat-card [@snFadeInDown] *ngIf="translationsLoaded">
  <sn-brand-logo
    type="horizontal"
    class="brand-logo__margin-vertical-md brand-logo__text-center"
  ></sn-brand-logo>
  <sn-alert dense type="danger" class="auth-activate-rounded-0" *ngIf="activationIsFail" && !serverErrors>
    <ng-container *ngIf="serverErrors; else defaultError">
      <div class="serverErrors" *ngFor="let error of serverErrors | keyvalue">
        <b>{{ toStartCase(error.key) }}</b>:
        <ng-container *ngIf="isArray(error.value); else singleError">
          <ul class="auth-activate-mb-0">
            <li *ngFor="let item of error.value">{{ item }}</li>
          </ul>
        </ng-container>
        <ng-template #singleError>
          <ul class="auth-activate-mb-0">
            <li>{{ error.value }}</li>
          </ul>
        </ng-template>
      </div>
    </ng-container>
    <ng-template #defaultError>
      <b>{{ 'auth.activate.errors.somethingWentWrong' | t }}</b><br />
      {{ 'auth.activate.errors.contactAdministrator' | t }}
    </ng-template>
  </sn-alert>

  <h3 class="auth-activate-text-center">{{ 'auth.activate.title' | t }}</h3>

  <sn-confirm-container
    [token]="token"
    [uid]="uid"
    (confirmError)="onError($event)"
    (serverError)="onServerError($event)"
    (confirm)="onConfirm()"
  >
  </sn-confirm-container>
</mat-card>
